import { writable } from 'svelte/store';
const { subscribe, update, set } = writable(false);
const isMobile = {
    subscribe,
    update,
    set
};
export default isMobile;
